import { isEqualByString } from 'utils/predicates/string/simple.util';

/**
 * Whether drag/move should be blocked for a time-off entry.
 *
 * Phase 3 widened can_edit_time_off_duration to cover moves as well as resize,
 * using the same all_staff / personal / no_access semantics.
 */
export const determineIfTimeOffMoveBlocked = ({ timeOffPerms, eventStylistId }) => {
  if (!timeOffPerms?.permsActive) return false;

  const { isEditDurationBlocked, isEditDurationPersonalOnly, accessStylistId } = timeOffPerms;

  if (isEditDurationBlocked) return true;

  return isEditDurationPersonalOnly && !isEqualByString(eventStylistId, accessStylistId);
};
